import React from "react"

import TaskTypeIcon from "../../../../../gd-components/icons/task-icon/task-icon-ui5"
import {FieldGraphTickLabelViewProps} from "../../../../render/graph-tick-label"
import Field_GraphTickLabelView from "../../../../proto/render/graph-tick-label";

const LABEL_SHOW_THRESHOLD = 100

const debug = false
// const debug = "FieldTaskType_GraphTickLabelView"

export default function FieldTaskType_GraphTickLabelView(props: FieldGraphTickLabelViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)
    const taskType = gd.session.taskTypes.get(value)!

    debug && console.log(debug, 'render', taskType, props)

    let showLabel = props.params.availableWidth > LABEL_SHOW_THRESHOLD

    const iconClasses = Classes({
        'm-r-5': showLabel
    })

    return (
        <Field_GraphTickLabelView {...props} hintName={taskType.name}>
            <TaskTypeIcon className={iconClasses} taskTypeId={taskType.id}/>
            {showLabel && <div className="ui5-txt-default-small txt-truncate">{taskType.name}</div>}
        </Field_GraphTickLabelView>
    )
}